import {
  Component,
  ChangeDetectionStrategy,
  DoCheck,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { IOption } from 'src/models/campaign';

@Component({
  selector: 'app-reactive-radio-input',
  templateUrl: './reactive-radio-input.component.html',
  styleUrls: ['./reactive-radio-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactiveRadioInputComponent implements DoCheck {
  /**
   * 'fieldId' is a unique field identification
   * Example: 'email', 'password'
   *    ---REQUIRED PROPERTY---
   */
  @Input() isInline = false;
  @Input() filedLabel: string;
  @Input() radioOptions: IOption[];
  @Input() radioValue: string;
  @Input() showTooltip = false;
  @Input() descriptionTooltip: string;
  @Input() topTooltipHover: number;
  @Input() leftTooltipHover: number;

  /**
   * 'control' is a reactive form validator/value controller
   *    ---REQUIRED PROPERTY---
   */
  @Input() control: AbstractControl;

  @Output() selectedOption = new EventEmitter<string>();

  private _validationErrors = new BehaviorSubject<object>(null);
  public validationErrors$ = this._validationErrors.asObservable();

  ngDoCheck() {
    if (this.control && this.control.touched && this.control.invalid) {
      this._validationErrors.next(this.control['errors']);
    } else {
      this._validationErrors.next(null);
    }
  }

  onSelectOption(value) {
    this.selectedOption.emit(value);
  }
}
